import React, { useState } from 'react'
import { processCallbackSingle, sendLoginPayload } from 'account-portal-library/lib/emailSignIn';
import { parseCookies, validateSessionToken, isValidGoToURL } from "account-portal-library/lib/helperFunctions";
import AppVars from './../../AppVars';
import Logger from '../../Logger.js';

import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

import Logo from '../../static/images/TO/toyota-logo.svg';
import LoadingGif from '../../static/images/loading.gif';
const ACCOUNT_LOCKED_URL = "/accountlocked";

let appVars = AppVars.getInstance();
let logger = Logger.getInstance();

const MfaTrustPage = ({ style = 'TO', payload }) => {

    const [loading, setLoading] = useState(false);

    const defaultUrl = appVars.getBaseUrl() + '/' + appVars.getName() + '/oauth2/realms/root/realms' + appVars.getRealm() + '/authorize?client_id=' + appVars.getDefaultClientId() + '&response_type=code&scope=openid%20profile&redirect_uri=' + appVars.getDefaultRedirectURI();

    const addTrustDevice = async (action) => {
        const url = appVars.getBaseUrl() + '/' + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
        const headers = {
            'Accept-API-Version': 'resource=2.0',
            'Content-Type': 'application/json'
        }
        const params = {
            'authIndexType': 'service',
            'authIndexValue': sessionStorage.AP_SSID?appVars.getPhoneSignInTree():appVars.getEmailSignInTree()
        }
        let trustPayload = processCallbackSingle(payload, action)
        const choiceResponse = await sendLoginPayload(trustPayload, url, headers, params)
        handleLoginResponse(choiceResponse)
    }

    const handleLoginResponse = (loginResponse) => {
        if (validateForm(loginResponse.status)) {
            handleSuccess(loginResponse);
        } else {
            handleFailure(loginResponse);
        }
    }

    const validateForm = (status) => {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    const checkToken = async (loginResponse) => {
        try {
            var tokenId = loginResponse.response.tokenId
            if (tokenId != null) {
                logger.log("test", tokenId)
                var validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                logger.log("test", validateResponse)
                return validateResponse.response.valid;
            } else {
                return false
            }
        }
        catch {
            return false
        }
    }

    const handleSuccess = async (loginResponse) => {
        logger.log("test", loginResponse)
        logger.log("test", loginResponse.response.callbacks)
        if (loginResponse.response.callbacks == null) {
            var tokenValid = await checkToken(loginResponse);
            setLoading(false)
            logger.log('stage', tokenValid)
            if (tokenValid) {
                const parsedCookies = parseCookies(document.cookie);
                if (Object.keys(parsedCookies).includes("goto") && isValidGoToURL('T', parsedCookies["goto"])) {
                    window.location.replace(parsedCookies["goto"])
                }
                else {
                    window.location.replace(defaultUrl);
                }
            } else {
                window.location.replace(appVars.getUnknownErrorURL(style));
            }
        } else {
            setLoading(false)
        }
    }

    const handleFailure = (loginResponse) => {
        var failureUrl = loginResponse.failureUrl
        //If invalid credentials
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            setLoading(false)
        }
        else {
            setLoading(false)
            window.location.replace(appVars.getUnknownErrorURL(style));
        }
    }

    const onSkip = () => {
        setLoading(true)
        addTrustDevice(1)
    }

    const onAdd = () => {
        setLoading(true)
        addTrustDevice(0)
    }

    return <div className="login-wrapper" >
        <div className="relative login-box">
            <img src={Logo} className="login-logo__TO absolute" alt="Toyota Owners"></img>
            <div className="title__TO left">Add trusted device</div>
            <div className="sign-in-mfa-grid">
                <div className="sign-in-subtitle-left sign-in-subtitle">Click an option below to add this device to your trusted devices.</div>
            </div>
            <div className='mfa-button-group login-item-height'>
                <div className="username-button-grid">
                    <Button bsPrefix="login-button__TO button-duration" type="submit" onClick={onAdd}>Add Device</Button>
                    <Button bsPrefix="login-button-outline__TO" type="submit" onClick={onSkip}>Skip</Button>
                </div>
            </div>
        </div>
        <Image data-testid="loadingGIF" className={`working ${loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
    </div>
}

export default MfaTrustPage;